import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { TagFilterInputGq } from '../../../../graphql/projects/models/TagFilterInputGq';
import VoxelPopoverMenuItem from '../../../voxel/PopoverMenu/VoxelPopoverMenuItem';

export interface HeadCellTagSelectionProps {
  optionDisplayName: string;
  option: TagFilterInputGq;
  filter: TagFilterInputGq[];
  handleFilterChange: (tag: TagFilterInputGq, checked: boolean) => void;
}

const HeadCellTagSelection: React.FC<HeadCellTagSelectionProps> = React.memo(
  ({ filter: filterValue, option, handleFilterChange, optionDisplayName }) => {
    const selected = filterValue.some(
      (o) => o.tagId === option.tagId && o.tagGroupId === option.tagGroupId
    );

    return (
      <VoxelPopoverMenuItem
        closePopoverOnClick={false}
        title={optionDisplayName}
        onClick={() =>
          handleFilterChange({ tagId: option.tagId, tagGroupId: option.tagGroupId }, !selected)
        }
        icon={<FontAwesomeIcon icon={faCheck} className={selected ? undefined : 'opacity-0'} />}
      />
    );
  }
);

export default HeadCellTagSelection;
